module.exports = __webpack_public_path__ + "128da0d999247043f56765104378724d.pdf";